/* Copyright (c) 2021-2024 VMware, Inc. All rights reserved. VMware Confidential */
import { HTTP_INTERCEPTORS } from "@angular/common/http";

import { AuthInterceptor } from "@app/services/http-interceptors/auth-interceptor";
import { HttpErrorInterceptor } from "@app/services/http-interceptors/http.error.interceptor";

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }
];
